import { IconProps } from './IconProps';

export const ChatBubbles = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.14652 9.20877H7.08397L3.54214 11.3339V9.08062C1.26934 8.54246 -0.239949 6.38717 0.0314997 4.06735C0.302948 1.74754 2.26905 -0.00109102 4.60469 5.10739e-07H8.14652C10.6895 5.10739e-07 12.7509 2.06145 12.7509 4.60438C12.7509 7.14732 10.6895 9.20877 8.14652 9.20877ZM8.14795 10.6247C10.9475 10.62 13.3752 8.68834 14.0089 5.96149V5.96149C15.9076 6.6687 17.1198 8.53524 16.9936 10.5575C16.8674 12.5797 15.4326 14.281 13.4607 14.7467V17L9.91886 14.8749H8.85631C7.09391 14.874 5.4869 13.8663 4.71855 12.2802L7.47783 10.6247H8.14795Z"
        fill="black"
      />
    </svg>
  );
};

